<ng-container *ngIf="rolesDeterminantsList.length">
    <label class="input-label mt-2">{{'Roles determinants' | translate}}</label>
    <div class="table-items">
        <div class="item">
            <div class="row cursor-row" (click)="all ? unselectAll() : selectAll()">
                <div class="col-auto align-items-center justify-content-start">
                    <span class="{{all ? 'fa-toggle-large-on toggle-primary' : 'fa-toggle-large-on fa-flip-horizontal toggle-disabled'}} fas toggle__icon"></span>
                </div>
                <div class="col pl-0 align-items-center justify-content-start">{{'All determinants' | translate}}</div>
            </div>
        </div>
        <div class="item" *ngFor="let det of rolesDeterminantsList; let i = index;">
            <div class="row cursor-row" (click)="determinantToggle(det)">
                <div class="col-auto align-items-center justify-content-start">
                    <span class="{{det.checked ? 'fa-toggle-large-on toggle-primary' : 'fa-toggle-large-on fa-flip-horizontal toggle-disabled'}} fas toggle__icon"></span>
                </div>
                <div class="col pl-0 align-items-center justify-content-start">{{ det.name }}</div>
            </div>
        </div>
    </div>
</ng-container>
